// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-info__image {
  max-width: 600px;
  max-height: 152px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/empty-info/EmptyInfo.less"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,iBAAA;AAAJ","sourcesContent":[".empty-info {\n  &__image {\n    max-width: 600px;\n    max-height: 152px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
